import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { WizardIdEnum } from '@app/core/model/enum/wizard-id.enum';
import { WizardManagerService } from '@app/core/service/wizards/wizard-manager.service';
import { of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';


interface WizardMenuItem {
  id: WizardIdEnum;
  label: string;
  description: string;
  hasBeenSeen: boolean;
}

@Component({
  selector: 'app-wizard-menu',
  templateUrl: './wizard-menu.component.html',
  styleUrls: ['./wizard-menu.component.scss']
})
export class WizardMenuComponent {
  @Input() inline: boolean = false;
  @Output() wizardStarted = new EventEmitter<WizardIdEnum>();
  @Output() close = new EventEmitter<void>();

  public availableWizards: WizardMenuItem[] = [];
  public isTogglingWizard = false;

  constructor(private wizardManager: WizardManagerService, private router: Router) { }

  ngOnInit(): void {
    this.loadAvailableWizards();
  }


  /**
   * Charge la liste des wizards disponibles
   */
  private loadAvailableWizards(): void {
    const wizards = this.wizardManager.listWizards();
    this.availableWizards = wizards
      // .filter(wizard => wizard.id !== WizardIdEnum.GUIDE_PRESENTATION)
      .map(wizard => ({
        id: wizard.id,
        label: this.wizardManager.getWizard(wizard.id).getLabel(),
        description: this.wizardManager.getWizard(wizard.id).getDescription(),
        hasBeenSeen: wizard.hasBeenSeen
      }));
  }

  /**
     * Démarre un wizard (gère la navigation en interne)
     */
  startWizard(wizardId: WizardIdEnum): void {
    const targetRoute = this.wizardManager.getWizardInitRoute(wizardId);
    const currentRoute = this.router.url.split('?')[0];

    // Marquer comme non-vu puis naviguer
    this.wizardManager.markAsUnseen(wizardId).subscribe(() => {
      // Notifier le parent pour fermer le menu
      this.close.emit();

      if (currentRoute === targetRoute) {
        // Reload si on est déjà sur la bonne route
        window.location.href = targetRoute;
      } else {
        // Navigation simple
        this.router.navigate([targetRoute]);
      }
    });
  }

  /**
   * Toggle le statut vu/non-vu
   */
  toggleWizardStatus(event: Event, wizardId: WizardIdEnum): void {
    event.stopPropagation();
    event.preventDefault();

    if (this.isTogglingWizard) return;

    const wizard = this.availableWizards.find(w => w.id === wizardId);
    if (!wizard) return;

    this.isTogglingWizard = true;

    of(wizard.hasBeenSeen).pipe(
      switchMap(hasBeenSeen =>
        hasBeenSeen
          ? this.wizardManager.markAsUnseen(wizardId)
          : this.wizardManager.markAsSeen(wizardId)
      ),
      tap(() => this.loadAvailableWizards()),
      finalize(() => this.isTogglingWizard = false)
    ).subscribe();
  }

  /**
   * Réinitialise tous les wizards
   */
  resetAllWizards(): void {
    if (confirm('Voulez-vous vraiment réinitialiser tous les guides ?')) {
      this.wizardManager.resetAllSeenFlags();
      this.loadAvailableWizards();
    }
  }

}
